import {ApiMessageDataGroup, DataGroupModel} from '../../../src/models/api/dataGroupModel';
import {MessageModel, MessageStatusesEnum} from '../../../src/models/api/messageModel';
import {DataState} from '../../../src/store/data/dataState';
import {logger} from '../logger/logger';
import {createOfflineCache} from './offlineResources';

/*
 * Draft message temporary (while saving on the server) offline caching.
 */

const cache = createOfflineCache('draftMessages', ApiMessageDataGroup, (dg) => dg.updatedAt || 0);

function addAsync(message: MessageModel, data: DataState) {
  if (message.status !== MessageStatusesEnum.DRAFT_COMPOSE) {
    logger.warn('Saving message offline with unexpected status', {
      message_status: message.status,
    });
  }

  const contacts = message.recipients.map((r) => {
    const contact = data.contacts[r.contactUid];
    if (!contact) {
      throw new Error(
        `Tried to save an offline message (${message.uid}) with a missing dependency: contacts/${r.contactUid}`,
      );
    }

    return contact;
  });

  const dataGroup: DataGroupModel = {
    messages: [message],
    contacts,
  };

  return cache.addAsync(message.uid, dataGroup);
}

function removeAsync(message: MessageModel) {
  return cache.removeAsync(message.uid);
}

export const offlineDraftMessages = {
  addAsync,
  removeAsync,
  readAllAsync: () => cache.readAllAsync(),
  readAllIdsAsync: () => cache.readAllIdsAsync(),
  addedIds$: cache.addedIds$,
};
